<template>
  <Table :columns="columns" :data="data"/>
</template>

<script>
  export default {
    props: {
      data: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },

    data() {
      return {
        columns: [
          {
            key: "materialNo",
            width: 160,
          },
        ],
      };
    },

    mounted() {
      console.log(this.data);
    },
  };
</script>
